import api from "../axiosIntercepture";

export const createPO = async (poData) => {
    try {
        const response = await api.post("purchase-order/create",poData);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const fetchPO = async (page, pageSize, filters) => {
    try {
        const sendObj = {
            filters: filters,
            limit: pageSize,
            page: page + 1
        }
        const response = await api.post(`purchase-order/fetch-multi-dynamic`, sendObj);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}
export const updatePO = async (poData) => {
    console.log("Updating PO with data:", poData);
    try {
        const response = await api.post(`purchase-order/update/${poData._id}`, poData);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

// export const getUniquePoNumber = async () => {
//     try {
//         const response = await api.post("global/unique/1");
//         // Extract the sequence value from the response
//         if (response.data?.success && response.data?.data?.sequence) {
//             return response.data.data.sequence;
//         }
//         return null;
//     } catch (err) {
//         console.error("Error fetching unique PO number:", err);
//         throw err?.response?.data?.message || "Failed to generate PO number";
//     }
// }

export const fetchPoDetailByID = async (id) => {
    try {
        const response = await api.post(`purchase-order/fetch?id=${id}`);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}